import Alpine from "alpinejs";

import contrastColor from "./contrastColor.js";
import insensitiveStringContains from "./insensitiveStringContains.js";
import phonenumber from "./phonenumber";
import storage from "./storage";
import template from "./template";
import truncate from "./truncate";
import utils from "./utils.js";
import updateAutosize from "./updateAutosize.js";

import { initForAlpine as initAPI } from "../framework/api.js";
import { initForAlpine as initDropdown } from "../framework/components/dropdown.js";
import { initForAlpine as initPetrobar } from "../framework/petrobar.js";
import { initForAlpine as initPopups } from "../framework/components/popup.js";
import { initForAlpine as initQuery } from "../framework/query.js";
import { initForAlpine as initSubmitOnChange } from "./submitOnChange.js";
import { initForAlpine as initToasts } from "../framework/components/toast.js";
import { initForAlpine as initClipboard } from "./clipboard.js";
import { initForAlpine as initDate } from "../utils/date.js";
import { initForAlpine as initMoney } from "../utils/money.js";
import { initForAlpine as initPageTabs } from "../layout/page-tabs.js";

window.Alpine = Alpine;

contrastColor(Alpine);
updateAutosize(Alpine);
insensitiveStringContains(Alpine);
phonenumber(Alpine);
storage(Alpine);
truncate(Alpine);
template(Alpine);

initAPI(Alpine);
initDropdown(Alpine);
initPetrobar(Alpine);
initPopups(Alpine);
initQuery(Alpine);
initSubmitOnChange(Alpine);
initToasts(Alpine);
initClipboard(Alpine);
initDate(Alpine);
initMoney(Alpine);
initPageTabs(Alpine);

// TODO: evaluate if this should be a magic instead!
Alpine.data("utils", utils);

export default Alpine;
